import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

/** Shared chrome for legal / contact policy pages */
const PolicyLayout = ({ title, subtitle, updated, children, testId }) => (
  <div className="min-h-screen" style={{ background: 'var(--background)' }} data-testid={testId}>
    <Navbar />
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="bg-white rounded-2xl shadow-md p-8 sm:p-12">
        <h1 className="text-3xl sm:text-4xl font-bold mb-2" style={{ color: 'var(--primary)' }}>
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-gray-500 mb-1">{subtitle}</p>
        )}
        {updated && (
          <p className="text-sm text-gray-400 mb-8">{updated}</p>
        )}
        <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
          {children}
        </div>
      </div>
    </div>
    <Footer />
  </div>
);

export const MetaBox = ({ rows }) => (
  <div className="bg-gray-50 rounded-lg p-4 text-sm not-prose space-y-1">
    {rows.map(([label, value]) => (
      <p key={label}>
        <strong>{label}:</strong> {value}
      </p>
    ))}
  </div>
);

export const H2 = ({ children }) => (
  <h2 className="text-xl font-bold mt-8" style={{ color: 'var(--primary)' }}>{children}</h2>
);

export const H3 = ({ children }) => (
  <h3 className="text-lg font-semibold mt-6 text-gray-800">{children}</h3>
);

export const Ul = ({ children }) => (
  <ul className="list-disc pl-6 space-y-1">{children}</ul>
);

export const SimpleTable = ({ headers, rows }) => (
  <div className="overflow-x-auto not-prose my-4">
    <table className="w-full text-sm border-collapse border border-gray-200">
      <thead>
        <tr className="bg-gray-50">
          {headers.map((h) => (
            <th key={h} className="border border-gray-200 px-3 py-2 text-left font-semibold text-gray-800">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i} className={i % 2 ? 'bg-gray-50/50' : ''}>
            {row.map((cell, j) => (
              <td key={j} className="border border-gray-200 px-3 py-2 align-top">{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default PolicyLayout;
